var App = App || {};

// This is a fix for the TextFormatterVideoEmbed ProcessWire module.
// The max width setting does not work on the responsive width setting.
// Instead of modifying the plugin which could be overwritten later, this
// pulls the element, wraps it in a div that can be sized/styled

App.TextFormatterVideoEmbedModifier = (function() {

  var initialize = function() {
    _convertAllEmbedsToResponsive();
  }

  var _convertAllEmbedsToResponsive = function() {
    $('.TextformatterVideoEmbed').each(function() {
      $(this).wrap("<div class='TextformatterVideoEmbed-container'></div>");
    })
  };

  return {
    initialize: initialize
  };
})();
